module.exports = __webpack_public_path__ + "static/media/home_meta_CO_cover.7c7203d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_meta_CO_cover.png
// module id = 206
// module chunks = 0